import { render, staticRenderFns } from "./UpdateRegionInfoModal.vue?vue&type=template&id=7ce7ff8c&scoped=true&"
import script from "./UpdateRegionInfoModal.vue?vue&type=script&lang=js&"
export * from "./UpdateRegionInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRegionInfoModal.vue?vue&type=style&index=0&id=7ce7ff8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce7ff8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLabel } from 'vuetify/lib/components/VLabel';
installComponents(component, {VDivider,VForm,VLabel})
